import { useQuery } from '@hooks/reactQuery';

import { getFilterThresholds } from '@api/map';

import { extractQueryParams } from '@utils/common';

import { DAY_IN_MS } from '@constants/common';
import { FILTER_THRESHOLDS } from '@constants/queryKeys';

export const useQueryAssetFilterThresholds = () => {
	const { data: thresholds } = useQuery({
		queryKey: [FILTER_THRESHOLDS],
		queryFn: extractQueryParams(getFilterThresholds),
		refetchOnWindowFocus: false,
		staleTime: DAY_IN_MS,
	});

	return {
		thresholds: thresholds || {},
	};
};
